<template><div><h1 id="lagerorte" tabindex="-1"><a class="header-anchor" href="#lagerorte"><span>Lagerorte</span></a></h1>
<p>Lagerorte — Definition einzelner Adressen als Lager</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Fenster werden einzelne Adressen als Lager festgelegt und lagerspezifische Zusatzdaten eingegeben.</p>
<p>Pfad: <code v-pre>Logistik → Lagerorte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>AdressNr.:</dt>
<dd>
<p>Personen-ID aus Adressenstamm</p>
</dd>
<dt>Name etc.:</dt>
<dd>
<p>Anzeige von Adressdaten aus Adressenstamm</p>
</dd>
<dt>MinusB:</dt>
<dd>
<p>Minusbestände erlauben? j/n</p>
</dd>
<dt>LgSt:</dt>
<dd>
<p>Lagerstatus</p>
</dd>
<dd>
<p>I = internes Lager</p>
</dd>
<dd>
<p>E = externes Lager</p>
</dd>
<dt>LBez.:</dt>
<dd>
<p>Lagerbezeichnung, freies Textfeld, 7 Zeichen, alphanumerisch, wird in den Partien und Artikelbewegungen neben der Lagernummer zur einfacheren Identifikation angezeigt</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


